import {RecommendationGroup} from "@/types";

export function getSelectedGroups(groups: RecommendationGroup[]) {
    return groups.filter((g) => g.isSelected)
}

export function getSelectedRecommendationsId(groups: RecommendationGroup[]): string[] {
    return groups
        .filter(g => g.isSelected)
        .flatMap(g => g.recommendations)
        .filter(r => r.isSelected)
        .map(r => r.id)
}

export function getAlreadyUpgradedRecommendations(groups: RecommendationGroup[]) {
    return groups
        .flatMap((g) => g.recommendations)
        .filter((r) => r.isUpgraded)
}

export function getPriceForGroup(group: RecommendationGroup): number {
    return group.recommendations
        .reduce((s, r) => (r.isSelected && r.info?.price != undefined ? s + r.info.price : s), 0)
}